export default "__VITE_ASSET__CRCs3znN__"